<header tuiNavigationHeader>
  @if (showMenuButton()) {
    <span (tuiActiveZoneChange)="onMoreActiveZone($event)">
      <button
        title="Menu"
        tuiIconButton
        appearance="secondary-grayscale"
        size="s"
        type="button"
        iconStart="@tui.menu"
        data-test="nav-menu"
        [tuiDropdown]="overflowMenu"
        [tuiDropdownManual]="moreOpen() && showMenuButton()"
        (click)="toggleMore()"
      >
        Menu
      </button>
    </span>
  }

  <a routerLink="/home" tuiNavigationLogo>
    <tui-icon icon="@tui.bar-chart-2" />
    <span class="nav-logo-text">{{ title }}</span>
  </a>

  <span
    tuiNavigationSegments
    class="nav-segments"
    #segments
    [class.nav-segments--measuring]="!measured()"
  >
    @for (item of eligibleItems(); track item.id; let idx = $index) {
      <span class="nav-item" [class.nav-item--overflowed]="idx >= visibleCount()">
        @if (item.children) {
          <span (tuiActiveZoneChange)="onItemActiveZone(item.id, $event)">
            <button
              #navItem
              appearance="secondary-grayscale"
              tuiButton
              tuiChevron
              type="button"
              [attr.data-test]="'nav-' + item.id"
              [tuiDropdown]="itemMenu"
              [tuiDropdownManual]="openItemId() === item.id && idx < visibleCount()"
              (click)="toggleItem(item.id)"
            >
              {{ item.label }}
            </button>
            <ng-template #itemMenu>
              <tui-data-list size="m" class="nav-menu">
                @for (child of item.children; track child.route) {
                  <a tuiOption [routerLink]="child.route" (click)="openItemId.set(null)">
                    {{ child.label }}
                  </a>
                }
              </tui-data-list>
            </ng-template>
          </span>
        } @else {
          <a
            #navItem
            appearance="secondary-grayscale"
            tuiButton
            [attr.data-test]="'nav-' + item.id"
            [routerLink]="item.route"
            routerLinkActive="active-link"
          >
            {{ item.label }}
          </a>
        }
      </span>
    }

    <span class="nav-item" [class.nav-item--overflowed]="!showMore()">
      <span (tuiActiveZoneChange)="onMoreActiveZone($event)">
        <button
          #moreBtn
          appearance="secondary-grayscale"
          tuiButton
          tuiChevron
          type="button"
          data-test="nav-more"
          [tuiDropdown]="overflowMenu"
          [tuiDropdownManual]="moreOpen() && showMore()"
          (click)="toggleMore()"
        >
          More
        </button>
      </span>
    </span>
  </span>

  <ng-template #overflowMenu>
    <tui-data-list size="l" class="nav-menu nav-menu--overflow">
      @for (group of overflowGroups(); track group.label) {
        <tui-opt-group [label]="group.label">
          @for (entry of group.entries; track entry.route) {
            <a tuiOption [routerLink]="entry.route" (click)="closeMore()">
              {{ entry.label }}
            </a>
          }
        </tui-opt-group>
      }
    </tui-data-list>
  </ng-template>

  <button
    tuiIconButton
    type="button"
    appearance="secondary-grayscale"
    size="s"
    [iconStart]="getThemeIcon()"
    (click)="toggleTheme()"
  >
    Toggle theme
  </button>

  <app-auth-buttons />
</header>
